import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AproveErrorpopupComponent } from './aprove-errorpopup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    AproveErrorpopupComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
        FormsModule,
        ReactiveFormsModule
  ]
})
export class AproveErrorpopupModule { }
